<template>
  <div>
    <table
      class="table-comment text-center"
    >
      <tr
        class="grey-td"
      >
        <!-- <td>倉庫</td> -->
        <td>類別</td>
        <td>時效</td>
        <td>價格</td>
      </tr>
      <tr
        v-for="feeItem in feeList"
        :key="feeItem.srid"
        class="card-bg"
      >
        <!-- <td nowrap>
          {{ feeItem.label }}
        </td> -->
        <td nowrap>
          {{ feeItem.srLabel | seaSrLabelToName }}
        </td>
        <td nowrap>
          {{ feeItem.timespanMin }}-{{ feeItem.timespanMax }}天
        </td>
        <td>
          每公斤{{ feeItem.fwFee }}元台幣
          <span v-if="feeItem.caiFee > 0">
            / 每才{{ feeItem.caiFee }}元台幣
          </span>
        </td>
      </tr>
    </table>
    <table class="table-comment contentTable">
      <tr>
        <td
          style="border-top:0"
        >
          <div class="subTitle text-left">
            體積重量
          </div>
        </td>
        <td>
          <div>
            無任何重量或體積限制。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            計重方式
          </div>
        </td>
        <td>
          <div>
            重量及才積兩者之間取最大金額收費。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            丟貨賠償
          </div>
        </td>
        <td>
          按丟失保價金額賠償
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            禁運品
          </div>
        </td>
        <td>
          <div>
            使用海運雜貨/家具前請務必使用“能寄嗎”查詢
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    inject: Boolean,
  },
  computed: {
    viewSeFeeType: {
      get () {
        return this.$store.state.shippingRate.viewSeFeeType
      },
      set (v) {
        this.$store.commit('shippingRate/setViewSeFeeType', v)
      }
    },
    feeList () {
      const list = this.$store.state.jyShippingRatesSource
        .filter(item => item.transport === 'sea' && item.addrid === '1596' && item.srTwAddrid === '3204')
      list.sort((a, b) => {
        if (a.addrid === '2769') {
          return -1
        }
        return 0
      })
      return list.map(whs => {
        const fee = {
          ...whs,
        }
        if (fee.srExtras && fee.srExtras.billboard) {
          Object.assign(fee, fee.srExtras.billboard)
        }

        return fee
      })
    },
  },
}
</script>
<style lang="postcss" scoped>
.grey-td {
  background: #efefef;
}
.dark {
  .grey-td {
    background: #353535;
  }
}
.feeTypeBtn {
  cursor: pointer;
}
.feeTypeIcon {
  font-size: 18px !important;
  margin-bottom: 1px;
  &.active{
    color: #F2B500;
  }
}
.table-comment {
  width: 100%;
  td {
    padding: 10px;
  }
}
.contentTable {
  tr:first-child td {
    border-top: 0;
  }
  td:first-child {
    width: 100px;
    border-right: 0;
  }
  td:nth-child(2){
    border-left: 0;
  }
  .subTitle:before {
    background: #F2B500;
  }
}
</style>
